import _Object$values from 'babel-runtime/core-js/object/values';
import _toConsumableArray from 'babel-runtime/helpers/toConsumableArray';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import _ from 'lodash';
import { Base64 } from 'js-base64';
import { cookStyleSchema, cookStyle } from '@/views/creative/utils/cook-style-schema.js';
import TextEditor from './text-editor.vue';
import globalEventBus, { events } from '@/event';
import { getCategoryName } from '@/views/creative/utils';
import { t } from '@/lang';
import { mapState } from 'vuex';
import { localLanguage } from '@/common/storage';

var getStyleSchema = function getStyleSchema(_ref) {
  var style = _ref.style,
      fontList = _ref.fontList;

  // gradient = true 开启渐变色，如果开启了渐变色，则使用 startColor 与 endColor
  // 如果使用单色 gradient 要为 false
  var filterAttrs = ['startColor', 'endColor', 'gradient', 'deletelineColor', 'deletelineSpacing', 'deletelineWidth', 'enableGlow', 'glowColor', 'glowBlur', 'lineSpacing', 'underlineWidth', 'underlineSpacing', 'underlineColor'];
  var styleSchema = {};
  _.each(style, function (val, key) {
    // 过滤不需要渲染 UI 的属性
    if (filterAttrs.includes(key)) return;
    var schema = cookStyleSchema(key, val);
    if (key === 'font') {
      schema.field.options = fontList;
    }
    schema.prop = key;
    _.set(styleSchema, '' + key, schema);
  });
  return styleSchema;
};

var order = ['color', 'gradient', 'startColor', 'endColor', 'fontSize', 'font', 'blod', 'bold', 'italic', 'alpha', 'stroke', 'strokeColor', 'enableShadow', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'enableGlow', 'glowColor', 'glowBlur'];

var defaultStartColor = '#ff0000';
var defaultEndColor = '#000000';

export default {
  components: {
    TextEditor: TextEditor
  },
  props: {
    languageInfo: {
      type: Object,
      required: true
    },
    languageInfoKey: {
      type: String,
      required: true
    },
    languageInfoLocal: {
      type: String,
      required: true
    },

    titleVisible: {
      type: Boolean,
      default: true
    },

    localVisible: {
      type: Boolean,
      default: false
    },

    category: {
      type: Object,
      required: false
    },

    hasApplyBtn: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      styleVisible: false,
      formConfig: {
        labelPosition: 'top',
        size: 'small',
        inline: false
      },
      styleEditor: {
        schema: null,
        model: null,
        __local: '',
        textKey: ''
      },
      inputAttrs: {
        type: 'textarea',
        autosize: { minRows: 1, maxRows: 3 },
        maxlength: 1000
      }
    };
  },


  computed: _extends({}, mapState({
    isCommonTemplateCustom: function isCommonTemplateCustom(state) {
      return state.creative.template.isCommonTemplateCustom;
    }
  }), {
    hasStyle: function hasStyle() {
      return !_.isEmpty(_.get(this.languageInfo, 'style'));
    },
    decodedKey: function decodedKey() {
      return this.decode(this.languageInfoKey);
    },
    categoryName: function categoryName() {
      return this.category ? getCategoryName(this.category) : '';
    },
    textKey: function textKey() {
      // 区分横竖屏文本
      var direction = '';
      if (/_v$/gi.test(this.decodedKey)) {
        direction = 'V';
      } else if (/_h$/gi.test(this.decodedKey)) {
        direction = 'H';
      }
      // 如果有 name 先使用 name，没有则使用属性 key
      if (this.languageInfo.name) {
        return direction ? this.languageInfo.name + '_' + direction : this.languageInfo.name;
      }

      return direction ? this.decodedKey + '_' + direction : this.decodedKey;
    },
    getDirection: function getDirection() {
      // 区分横竖屏,横屏返回‘竖’ 竖屏返回‘横’
      if (/_v$/gi.test(this.decodedKey)) {
        return t('playTurbo.custom.textEditButton.applyToScreen[0]');
      } else if (/_h$/gi.test(this.decodedKey)) {
        return t('playTurbo.custom.textEditButton.applyToScreen[1]');
      }
      return '';
    },
    lang: function lang() {
      switch (localLanguage.get()) {
        case 'en':
          return 'en';
        case 'ja':
          return 'ja';
        default:
          return 'zh';
      }
    },
    className: function className() {
      return 'app-lang-' + this.lang;
    }
  }),

  watch: {
    styleVisible: function styleVisible(val) {
      if (val === true) {
        this.initStyleEditor(this.languageInfoKey, this.languageInfoLocal);
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              globalEventBus.$on(events.DM.STYLE_EDITOR_POPOVER.CLOSE, function () {
                if (_this.styleVisible) _this.styleVisible = false;
              });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: {
    decode: function decode(val) {
      return Base64.decode(val);
    },
    initStyleEditor: function initStyleEditor(parentKey, __local) {
      var _this2 = this;

      var fontList = this.$store.getters.fontList;
      this.styleEditor.model = _.cloneDeep(this.languageInfo);
      var currentStyle = cookStyle(this.styleEditor.model.style ? _extends({
        // font\color\startColor\endColor 默认支持
        font: '',
        color: '',
        startColor: defaultStartColor,
        endColor: defaultEndColor,
        gradient: false
      }, this.styleEditor.model.style) : null);
      this.styleEditor.model.style = currentStyle;
      var schema = getStyleSchema({
        style: currentStyle,
        fontList: fontList
      });
      this.styleEditor.schema = [];
      _.each(order, function (item) {
        if (schema[item]) {
          _this2.styleEditor.schema.push(schema[item]);
          delete schema[item];
        }
      });
      // 处理 schema 还有值的情况
      this.styleEditor.schema = [].concat(_toConsumableArray(this.styleEditor.schema), _toConsumableArray(_Object$values(schema)));
      this.styleEditor.__local = __local;
      this.styleEditor.textKey = parentKey;
    },
    closeStyleEditorDialog: function closeStyleEditorDialog() {
      this.styleVisible = false;
    },
    handleTextEditorSubmit: function handleTextEditorSubmit(model) {
      this.$emit('submit', {
        model: _extends({}, model, {
          value: this.languageInfo.value
        }),
        local: this.languageInfoLocal,
        key: this.languageInfoKey
      });
    },
    handleInputChange: function handleInputChange(value) {
      this.$emit('submit', {
        model: _extends({}, this.languageInfo, this.styleEditor.model, {
          value: value
        }),
        local: this.languageInfoLocal,
        key: this.languageInfoKey
      });
    },
    enterHandler: function enterHandler(v) {
      this.$refs.languageValue.blur();
    },

    // 一键应用到语言 、 一键应用到横/竖屏
    handleApplySubmit: function handleApplySubmit(model, type) {
      this.$emit('applySubmit', {
        model: _extends({}, model, {
          value: this.languageInfo.value
        }),
        local: this.languageInfoLocal,
        key: this.languageInfoKey,
        type: type
      });
    },

    // 应用到同语言的所有文本
    handleApplyFontToOtherSubmit: function handleApplyFontToOtherSubmit(model) {
      this.$emit('applyLanguageSubmit', {
        model: _extends({}, model),
        local: this.languageInfoLocal,
        key: this.languageInfoKey
      });
    }
  }
};